import cn from '@components/utils/cn'
import { Progress } from '@components/atoms/Progress'

import { scopedTranslation } from '@utils/I18n'

import { coveragePct, coverState, type CoverState } from './rosterCoverage'

const t = scopedTranslation('roster_board')

const COVER_BAR: Record<CoverState, string> = {
  empty: 'tw:bg-error-500',
  partial: 'tw:bg-warning-500',
  full: 'tw:bg-success-500',
}

const COVER_TRACK: Record<CoverState, string> = {
  empty: 'tw:bg-error-100',
  partial: 'tw:bg-warning-100',
  full: 'tw:bg-success-100',
}

export function CoverageMeter({ filled, total }: { filled: number; total: number }) {
  const state = coverState(filled, total)

  return (
    <div role="img" aria-label={t('coverage_aria', { filled, total })} className="tw:flex tw:w-28 tw:flex-col tw:gap-1">
      <div className="tw:flex tw:items-center tw:justify-between tw:text-xs tw:font-semibold tw:text-gray-600">
        <span aria-hidden>
          {filled}/{total}
        </span>
      </div>
      <Progress
        aria-hidden
        value={coveragePct(filled, total)}
        progressColor={COVER_BAR[state]}
        className={cn('tw:h-1.5', COVER_TRACK[state])}
      />
    </div>
  )
}
